module.exports = __webpack_public_path__ + "img/dev-logo.5489885a.png";